/**
 * Fallback delay (ms) before the collapsed bubble morphs into the proactive
 * greeting card. Used only when the backend does not deliver a value
 * (older servers) or delivers something unusable. Mirrors the server's
 * Chat.DEFAULT_PROACTIVE_DELAY_MS.
 */
export const DEFAULT_PROACTIVE_DELAY_MS = 5000;

/**
 * Resolves the proactive delay to use from the value delivered by the backend
 * (`proactiveDelayMs` in the /chat_bot/omq/init payload).
 *
 * @param value the raw backend value
 * @returns the configured delay when it is a finite, non-negative number,
 *          otherwise DEFAULT_PROACTIVE_DELAY_MS
 */
export function resolveProactiveDelayMs(value: unknown): number {
  if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
    return value;
  }
  return DEFAULT_PROACTIVE_DELAY_MS;
}
